// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3yqWt","notes":"Notes_notes__1yKzp"};